function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { useState } from 'react';
import { ButtonLink, Card, DescriptionList, Divider, Flex, Heading, Select, Text } from '@applyboard/crystal-ui';
import { formatCurrency, useEventTracker } from '@applyboard/ui-utils';
import { PaymentAccountType, supportedCurrenciesInIndianLegalEntity, useBalances } from "../../data/balances";
import { useCurrencies } from "../../data/currencies";
import { usePayments } from "../../data/payments";
import { adaptBalances, currencyObjectSelector } from "./utils";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "@emotion/react";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var BALANCE_TITLES = new Map([[PaymentAccountType.Commission, 'Commissions'], [PaymentAccountType.ApplyCredit, 'ApplyCredits'], [PaymentAccountType.AdvancedCommission, 'Advanced Commissions']]);
function useYourBalance(_ref) {
  var userId = _ref.userId;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    currency = _useState2[0],
    setCurrency = _useState2[1];
  var _useCurrencies = useCurrencies(),
    currencies = _useCurrencies.currencies,
    isFetchingCurrencies = _useCurrencies.isFetchingCurrencies;
  var currenciesWithInr = [].concat(_toConsumableArray(currencies), _toConsumableArray(supportedCurrenciesInIndianLegalEntity));
  var _usePayments = usePayments(userId),
    paymentProps = _usePayments.paymentProps;
  var _useBalances = useBalances(paymentProps === null || paymentProps === void 0 ? void 0 : paymentProps.billingAccountUuid, adaptBalances),
    userAccountBalances = _useBalances.userAccountBalances,
    isFetchingBalances = _useBalances.isLoading;

  // filtering out currencies without any balance amount
  var currenciesWithAmount = currenciesWithInr.filter(function (currency) {
    return userAccountBalances[currency.code];
  });
  var currencyOptions = currenciesWithAmount.map(function (_ref2) {
    var code = _ref2.code;
    return {
      label: code,
      value: code
    };
  });

  // make CAD default currency
  if (!currency && currenciesWithAmount.length) {
    var _currenciesWithAmount;
    setCurrency(currenciesWithAmount.some(function (currency) {
      return currency.code === 'CAD';
    }) ? 'CAD' : (_currenciesWithAmount = currenciesWithAmount[0]) === null || _currenciesWithAmount === void 0 ? void 0 : _currenciesWithAmount.code);
  }
  var balanceNamesWithAmount = Object.values(PaymentAccountType).filter(function (balanceName) {
    var _userAccountBalances$, _userAccountBalances$2;
    return (balanceName !== PaymentAccountType.AdvancedCommission || ((_userAccountBalances$ = userAccountBalances[currency]) === null || _userAccountBalances$ === void 0 ? void 0 : _userAccountBalances$[balanceName]) !== 0) && ((_userAccountBalances$2 = userAccountBalances[currency]) === null || _userAccountBalances$2 === void 0 ? void 0 : _userAccountBalances$2[balanceName]) !== undefined;
  });
  var balances = balanceNamesWithAmount.map(function (balanceName) {
    var _userAccountBalances$3;
    return {
      key: balanceName,
      term: BALANCE_TITLES.get(balanceName),
      details: formatCurrency((_userAccountBalances$3 = userAccountBalances[currency]) === null || _userAccountBalances$3 === void 0 ? void 0 : _userAccountBalances$3[balanceName], currencyObjectSelector(currenciesWithInr, currency), true, true)
    };
  });
  return {
    currency: currency,
    setCurrency: setCurrency,
    currencyOptions: currencyOptions,
    shouldHide: isFetchingCurrencies || !currenciesWithAmount.length,
    balances: balances,
    displayBalances: !isFetchingBalances && balanceNamesWithAmount.length
  };
}
export function YourBalance(_ref3) {
  var userId = _ref3.userId;
  var _useYourBalance = useYourBalance({
      userId: userId
    }),
    currency = _useYourBalance.currency,
    setCurrency = _useYourBalance.setCurrency,
    shouldHide = _useYourBalance.shouldHide,
    currencyOptions = _useYourBalance.currencyOptions,
    displayBalances = _useYourBalance.displayBalances,
    balances = _useYourBalance.balances;
  if (shouldHide) {
    return null;
  }
  return _jsxs(Card, {
    as: "article",
    variant: "outlined",
    "aria-label": "Your Account Balances",
    children: [_jsx(Card.Header, {
      children: _jsxs(Flex, {
        direction: "row",
        justify: "between",
        align: "center",
        children: [_jsx(Heading, {
          variant: "titleM",
          level: 3,
          children: "Your balance"
        }), _jsx(Select, {
          appearance: "native",
          "aria-label": "currency selector",
          onChange: setCurrency,
          value: currency,
          children: currencyOptions.map(function (opt) {
            return _createElement(Select.Option, _objectSpread(_objectSpread({}, opt), {}, {
              key: opt.value
            }));
          })
        })]
      })
    }), _jsx(Divider, {
      direction: "horizontal"
    }), _jsxs(Flex, {
      direction: "column",
      gap: 4,
      children: [displayBalances && _jsx(DescriptionList, {
        "aria-label": "list of accounts and their respective balances",
        children: balances.map(function (_ref4) {
          var key = _ref4.key,
            term = _ref4.term,
            details = _ref4.details;
          return _jsx(DescriptionList.Item, {
            term: term,
            details: _jsx(Text, {
              variant: "titleM",
              children: details
            })
          }, key);
        })
      }), _jsx(WithdrawalLink, {})]
    })]
  });
}
function WithdrawalLink() {
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var publishEvent = function publishEvent(clickItem) {
    trackEvent({
      event: "Agent Dashboard - Clicked ".concat(clickItem)
    });
  };
  return _jsx(Text, {
    variant: "labelL",
    children: _jsx(ButtonLink, {
      href: "/withdrawal_request",
      onClick: function onClick() {
        return publishEvent('Withdrawal Instructions');
      },
      intent: "primary",
      variant: "highlighted",
      mode: "override_user_choice_and_open_in_new_tab",
      children: "Request commission withdrawal"
    })
  });
}